import { cn } from '@workspace/lib';
import Link from 'next/link';
import { Icon, Picture, TextButton, Typography } from '@workspace/ui/common';
import { ApplicationItemProps } from '../application.types';

export function ApplicationItem({ item, className = '', noLinkWrapper }: ApplicationItemProps) {
  const href =
    item?.url ??
    (item?.slug?.current && item?.type
      ? `/${item.type === 'blogs' ? 'blog' : item.type}/${item.slug.current}`
      : undefined);

  return (
    <>
      {href && !noLinkWrapper && (
        <Link
          href={href}
          className={cn('max-h-132 rounded-md group  border border-secondary-100 rounded-b-md', className)}
        >
          <div className="image-container bg-secondary-100 h-72.5 rounded-t-md overflow-hidden">
            {item?.thumbnail && (
              <Picture
                image={item.thumbnail}
                desktopWidth={384}
                desktopHeight={290}
                className="w-full h-full rounded-t-md"
                imgClassName="object-cover transition-transform duration-300 ease-in-out group-hover:scale-[1.03]"
              />
            )}
          </div>

          <div className="py-md px-sm flex flex-col gap-lg  rounded-b-md md:min-h-59.5 justify-between md:gap-0 h-59.5">
            <div className="flex flex-col gap-xs">
              <Typography
                variant="h3"
                className="text-secondary-400 line-clamp-3 font-semibold! md:font-bold! text-lg!"
                title={item?.title}
                styleVariant="h6"
              >
                {item?.title}
              </Typography>

              <Typography
                variant="bodySm"
                className="text-secondary-500 line-clamp-3 font-body h-fit leading-5"
                title={item?.shortDescription}
              >
                {item?.shortDescription}
              </Typography>
            </div>

            {/* Actions */}
            <div className="flex items-center justify-end gap-4">
              <div className="flex items-center gap-1">
                <TextButton
                  isDisabled={false}
                  className="bg-transparent p-0 font-semibold! text-primary hover:no-underline!"
                >
                  Read More
                </TextButton>
                <Icon
                  name="arrowRightIcon"
                  size={24}
                  className="text-primary transition-transform duration-300 ease-in-out group-hover:translate-x-1"
                />
              </div>

              {item?.campaign?.url && (
                <Link
                  href={item.campaign.url}
                  target={item.campaign.type === 'external' ? '_blank' : undefined}
                  className="text-sm text-primary hover:underline"
                  rel="noreferrer"
                >
                  Promo
                </Link>
              )}
            </div>
          </div>
        </Link>
      )}
    </>
  );
}
